import getConfig from 'next/config';

/**
 * @param {MetaTagsProps} props
 * @returns {React.ReactElement} The rendered component
 */
const MetaTags = ({ canonicalUrl, description, noIndex, language }) => {
  const { publicRuntimeConfig } = getConfig();
  let lang = '';

  if (publicRuntimeConfig.defaultLanguage !== language) {
    lang = `/${language}`;
  }

  return (
    <>
      <meta content={description} name="description" />
      {canonicalUrl && <link rel="canonical" href={`${lang}${canonicalUrl}`} />}
      <meta name="format-detection" content="telephone=no" />
      <meta name="google" content="notranslate" />
      <meta name="msapplication-tap-highlight" content="no" />
      {noIndex && <meta name="robots" content="noindex,nofollow" />}
    </>
  );
};

export default MetaTags;
